<template>
    <v-app>
        <v-toolbar app class="app-toolbar">
            <v-btn :ripple="false" icon @click="$router.go(-1)">
                <v-icon class="icon-light">arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Inbox</v-toolbar-title>
        </v-toolbar>
        <v-content pa-0 style="padding-bottom: 127px" id="inbox-content">
            <v-layout row flex>
                <v-list three-line style="width: 100%">
                    <template v-for="(item, index) in chats">
                        <v-divider v-if="index > 0"></v-divider>

                        <v-list-tile :to="{name: 'authenticated.chat', params: {chatId: item.chat_id}}" :key="item.chat_id" avatar @click="">
                            <v-list-tile-avatar>
                                <img :src="item.practioner_photo">
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ item.practitioner_name }} {{ item.practitioner_surname }}
                                </v-list-tile-title>

                                <v-list-tile-sub-title class="inbox-qualification">
                                    {{ item.practioner_qualifications }}
                                </v-list-tile-sub-title>

                                <v-list-tile-sub-title class="chat-date">
                                    {{ item.chat_date_start }}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-list>
            </v-layout>
        </v-content>
        <div id="inbox-footer" v-if="chats != null">
            <div style="display: flex; padding: 5px">
                <div style="flex-grow: 1">Total Questions:</div>
                <div>{{ questions }}</div>
            </div>
            <v-divider style="border-color: rgba(255, 255, 255, 0.2)"></v-divider>
            <div style="display: flex; padding: 5px">
                <div style="flex-grow: 1">Total Time:</div>
                <div>{{ displayTime }}</div>
            </div>
            <v-divider style="border-color: rgba(255, 255, 255, 0.2)"></v-divider>
            <div style="display: flex; padding: 5px">
                <div style="flex-grow: 1">Total Sessions:</div>
                <div>{{ chats.length }}</div>
            </div>
        </div>
    </v-app>
</template>
<script>
    import vas from '@/lib/VASClient';
    import {mapState, mapActions} from 'vuex'
    var moment = require('moment-timezone');

    export default {
        data() {
            return {
                chats: null,
                questions: 0,
                time: 0,
                displayTime: 0
            }
        },
        created() {
            var self = this;

            // Repository.Chat.all(this.auth.user.user_id, function (result) {
            //     self.chats = result;
            // });
            //
            // return;

            Loading.show('');

            vas.getInbox(this.auth.user.cell_no, this.auth.user.user_id).then(function (result) {
                self.chats = result.chats;
                self.calculateTotals();

                Loading.hide();
            }).catch(function () {
                Loading.hide();
            });
        },
        methods: {
            calculateTotals() {
                var self = this;

                this.chats.forEach(function (chat) {
                    if (chat.practioner_photo == null || chat.practioner_photo == '') {
                        chat.practioner_photo = require('../../../variants/' + BUILD_VARIANT + "/practitioner.png");
                    } else {
                        chat.practioner_photo = vas.imageUrl(chat.practioner_photo);
                    }

                    self.questions += parseInt(chat.chat_message_count);

                    if (chat.chat_date_dispositioned != null && chat.chat_date_start != null) {
                        var start = moment().tz(chat.chat_date_start, "YYYY-MM-DD HH:mm:ss", 'Africa/Johannesburg');
                        var end = moment().tz(chat.chat_date_dispositioned, "YYYY-MM-DD HH:mm:ss", 'Africa/Johannesburg');

                        self.time += (end.valueOf() - start.valueOf());
                    }
                });

                var milliseconds = parseInt((self.time % 1000) / 100),
                    seconds = parseInt((self.time / 1000) % 60),
                    minutes = parseInt((self.time / (1000 * 60)) % 60),
                    hours = parseInt((self.time / (1000 * 60 * 60)) % 24);

                hours = (hours < 10) ? "0" + hours : hours;
                minutes = (minutes < 10) ? "0" + minutes : minutes;
                seconds = (seconds < 10) ? "0" + seconds : seconds;

                self.displayTime = hours + ":" + minutes + ":" + seconds;
            }
        },
        computed: {
            ...mapState(['auth'])
        }
    }
</script>
<style>
    .inbox-footer table {
        width: 100%;
        margin: 10px;
    }

    .v-avatar img {
        border-radius: 50%;
    }
</style>
